"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockPublicTeaser = void 0;
const createMockPublicTeaser = (overwrites = {}) => {
    return Object.assign({ runRateRevenueValue: undefined, runRateRevenueAsOf: undefined, revenue: undefined, revenueAsOf: undefined, growthRateValue: undefined, growthRateLabelValue: undefined, growthRateAsOfValue: undefined, margins: undefined, marginsAsOf: undefined }, overwrites);
};
exports.createMockPublicTeaser = createMockPublicTeaser;
//# sourceMappingURL=PublicTeaser.factory.js.map